import React from "react";
import { Message } from "common/utils/chatAgent/types";
import { MarkdownContainer } from "../../Common/__styles__/MarkdownContainer";
import { Icon as LucideIcon } from "../../Common/Icons/LucideIcons";
import {
  AssistantHeader,
  AssistantName,
  HistoryContainer,
  LoadingIndicator,
  MessageContainer,
  MessageContent,
  ThinkingText,
  UserMessageBubble,
  UserMessageContainer,
  UserMessageText,
} from "./__styles__/ChatHistory";
import ToolActivityCard from "./ToolActivityCard";

export interface ChatHistoryProps {
  messages: Message[];
  isLoading?: boolean;
}

const ChatHistory: React.FC<ChatHistoryProps> = ({
  messages,
  isLoading = false,
}) => {
  const showLoading =
    isLoading &&
    (messages.length === 0 || messages[messages.length - 1]?.role === "user");

  return (
    <HistoryContainer>
      {messages.map(message => (
        <MessageContainer key={message.id}>
          {message.role === "assistant" ? (
            <>
              <AssistantHeader>
                <LucideIcon
                  iconName="sparkles"
                  color="contentPrimary"
                  size={14}
                />
                <AssistantName>Assistant</AssistantName>
              </AssistantHeader>
              <MessageContent>
                {message.parts.map((part, i: number) => {
                  if (part.type === "text") {
                    return (
                      <MarkdownContainer
                        key={i}
                        markdown={part.text}
                        css={{
                          fontSize: "14px",
                          fontFamily: "Inter",
                          lineHeight: "20px",
                          color: "#0C1629",
                          p: {
                            margin: 0,
                            fontSize: "14px",
                            fontFamily: "Inter",
                            lineHeight: "20px",
                            color: "#0C1629",
                          },
                        }}
                      />
                    );
                  }
                  if (part.type === "tool-activity") {
                    return (
                      <ToolActivityCard
                        key={part.activity.toolCallId}
                        activity={part.activity}
                      />
                    );
                  }
                  return null;
                })}
              </MessageContent>
            </>
          ) : message.role === "user" ? (
            <UserMessageContainer>
              <UserMessageBubble>
                <UserMessageText>
                  {message.parts.map(part => {
                    if (part.type === "text") return part.text;
                    return null;
                  })}
                </UserMessageText>
              </UserMessageBubble>
            </UserMessageContainer>
          ) : null}
        </MessageContainer>
      ))}
      {showLoading && (
        <MessageContainer>
          <AssistantHeader>
            <LucideIcon iconName="sparkles" color="contentPrimary" size={14} />
            <AssistantName>Assistant</AssistantName>
          </AssistantHeader>
          <MessageContent>
            <LoadingIndicator role="status" aria-live="polite">
              <ThinkingText>Thinking...</ThinkingText>
            </LoadingIndicator>
          </MessageContent>
        </MessageContainer>
      )}
    </HistoryContainer>
  );
};

export default ChatHistory;
